import { SurchargeMessage } from '../../../../types/SurchargeMessage';
import { SurchargeType } from '../../../../types/SurchargeType';
import { DefaultCell } from '../../../cdl/TableBuilder/components/DefaultCell';
import { StyledDefaultTableBodyRow } from '../../../cdl/TableBuilder/components/StyledDefaultTableBodyRow';
import { Text } from '../../../cdl/Text/Text';
import { formatMoney } from '../../helpers/formatMoney.helper';
import { translate } from '../../helpers/translate.helper';
import { Characters } from '../../helpers/unicode.helper';
import { useEnums } from '../../hooks/useEnums';
import { getCellEmphasis } from '../../ReadOnlyProductTable/components/getCellEmphasis';
import { Box } from '../../ui/Box';

interface SurchargeRowProps {
    surcharge: SurchargeMessage;
    tableRowIndex: number;
    showPrices: boolean;
}

export const SurchargeRow = ({ surcharge, tableRowIndex, showPrices }: SurchargeRowProps) => {
    const { getHumanReadableValue } = useEnums();
    const formattedValue = surcharge.value?.value
        ? formatMoney({
              value: surcharge.value.value,
              currency: surcharge.value.currency,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
          })
        : Characters.EN_DASH;

    return (
        <StyledDefaultTableBodyRow
            alternateRowColors
            grow
            active={false}
            selectable={false}
            disabled={surcharge.deleted}
        >
            <DefaultCell numeric>{tableRowIndex + 1}</DefaultCell>
            <DefaultCell>
                <Box display="grid">
                    <Text color={surcharge.changes.nameChanged ? 'attention.foreground' : 'foreground.attention'}>
                        {surcharge.surchargeType === SurchargeType.CUSTOM
                            ? surcharge.name
                            : getHumanReadableValue('surchargeType', surcharge.surchargeType)}
                    </Text>
                    <Text variant="extraSmall" color={surcharge.deleted ? 'foreground.disabled' : 'foreground.subtle'}>
                        {translate(
                            surcharge.value.value > 0 ? 'order.surcharges.surcharge' : 'order.surcharges.waiver'
                        )}
                    </Text>
                </Box>
            </DefaultCell>

            {showPrices ? (
                <>
                    <DefaultCell colSpan={5} />
                    <DefaultCell emphasis={getCellEmphasis(surcharge.changes.valueChanged)} numeric>
                        {formattedValue}
                    </DefaultCell>
                    <DefaultCell emphasis={getCellEmphasis(surcharge.changes.valueChanged)} numeric>
                        {formattedValue}
                    </DefaultCell>
                </>
            ) : null}
        </StyledDefaultTableBodyRow>
    );
};
